/***************************************************************************************************
** useFormValidation
***************************************************************************************************/

import { useState, useCallback } from "react";

// SOURCE: https://emailregex.com/
const EMAIL_FORMAT_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// SOURCE: https://urlregex.com/
const URL_FORMAT_REGEX = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;

const validateIsRequired = (value) => ((value !== undefined) && (value !== null) && (String(value).trim() !== ""));
const validateHasEmailFormat = (value) => (!value || EMAIL_FORMAT_REGEX.test(value));
const validateHasUrlFormat = (value) => (!value || URL_FORMAT_REGEX.test(value));

const FIELD_VALIDATION_TYPES = [
  {
    type: "isRequired",
    validateFn: validateIsRequired,
    errorText: "This field is required",
  },
  {
    type: "hasEmailFormat",
    validateFn: validateHasEmailFormat,
    errorText: "This field has an invalid email",
  },
  {
    type: "hasUrlFormat",
    validateFn: validateHasUrlFormat,
    errorText: "This field has an invalid url",
  },
];

const DEFAULT_SET_FORM_ERRORS_FUNCTION = (() => {});

export default function useFormValidation(props) {
  const {
    fieldValidations,
  } = props;

  const [validationErrors, setValidationErrors] = useState({});
  // const setValidationError = (name, error) => setValidationErrors(errors => ({ ...errors, [name]: error }));
  // const clearValidationError = (name) => delete validationErrors[name];

  const setFormErrors = props.setFormErrors || DEFAULT_SET_FORM_ERRORS_FUNCTION;

  /**************************************************************************************************/

  // const __validationFieldsByType = React.useCallback((type) => {
  //   const fieldValidationsArray = Object.entries(fieldValidations);
  //   const fields = fieldValidationsArray.filter(([_name, validations]) => (validations.includes(type)));
  //   const fieldNames = fields.map(([name, _validations]) => name);

  //   return fieldNames;
  // }, [fieldValidations]);

  const __validationFieldsByType = useCallback((type) => {
    const fieldValidationsArray = Object.entries(fieldValidations);
    const fieldNames =  fieldValidationsArray.reduce((names, [name, validations]) => (validations[type] ? [...names, name] : names), []);

    return fieldNames;
  }, [fieldValidations]);

  /**************************************************************************************************/

  const validate = useCallback((values) => {
    let isFormValid = true;
    const errors = {};

    for (const { type, validateFn, errorText } of FIELD_VALIDATION_TYPES) {
      const fields = __validationFieldsByType(type);

      fields.forEach((name) => {
        const fieldValue = values[name];
        const isFieldValid = validateFn(fieldValue);

        if (!errors[name] && !isFieldValid) {
          isFormValid = false;
          errors[name] = errorText;
        }
      });
    }

    setValidationErrors(errors);
    setFormErrors(errors);

    return isFormValid;
  }, [__validationFieldsByType, setFormErrors]);

  /**************************************************************************************************/

  return {
    validate,
    validationErrors,
  };
}
